
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.738 4.634a2.165 2.165 0 013.06 0L19.367 6.2a2.166 2.166 0 010 3.061L9.263 19.366A2.165 2.165 0 017.732 20h-3.01A.722.722 0 014 19.278v-3.01c0-.574.228-1.125.634-1.531L14.738 4.634zm2.04 1.02a.722.722 0 00-1.02 0L14.402 7.01l2.588 2.588 1.356-1.356a.722.722 0 000-1.02L16.78 5.654zm-.809 4.964l-2.587-2.587-7.727 7.726a.721.721 0 00-.212.51v2.29h2.289a.722.722 0 00.51-.212l7.727-7.726z"}})])
          )
        }
      }
    